import React from 'react';
import styled from 'styled-components';

/** Display size for `public/distorted-future.png` in the window (1024² asset shown at 227²). */
export const SPIRAL_MEDIA_SIZE = 227;

/** Click point on `public/portal-cursor-64.png` (tip of arrow). Adjust if needed. */
const PORTAL_CURSOR_HOTSPOT = '0 0';

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: url('/portal-cursor-64.png') ${PORTAL_CURSOR_HOTSPOT}, auto;
`;

const Media = styled.img`
  width: ${SPIRAL_MEDIA_SIZE}px;
  height: ${SPIRAL_MEDIA_SIZE}px;
  display: block;
  object-fit: contain;
  cursor: inherit;
  background: #000;
`;

export default function SpiralViewer() {
  return (
    <Wrap
      onClick={() => {
        window.location.href = '/portal';
      }}
      title="Enter the BMUD Portal"
    >
      <Media src="/distorted-future.png" alt="" draggable={false} />
    </Wrap>
  );
}
